const RollbackIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="64px"
      height="64px"
      viewBox="0 0 64 64"
      enableBackground="new 0 0 64 64"
      xmlSpace="preserve"
    >
      <image
        id="image0"
        width="64"
        height="64"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABqlBMVEUAAAAjsf8ksP8jsP8lsP8nsf8jsP8jsf8hr/8jsP8jsf8AgP8isf8jsP8is/8isP8ksP8jsP8jsf8ksv8jsP8jsP8ksf8hsP8rqv8Aqv8jr/8jsP8jsf8jsP8isP8hrf8isP8ir/8etP8jsP8jsP8isP8jsP8jsP8ktv8jsP8isP8jsP8isP8isP8jsP8hsf8jsP8isf9Bjf82l/82mv9Di/83m/8ym/8+kP9Div83m/8A//84lv9Ajf8tlv83m/86lf8rnP86k/84mP83mP9CjP9Bjf9An/83nv89kP85mP83lv9Di/81nv82mf9Bjv86lv89o/80m/84mv83lv87k/8/kP9Cjf84mP85l/85mf86lP9Ci/83l/8wn/83mP8+kP83mv84mf85mP82m/89kv8+kP83mP82mf83mf81mP9Ei/87lv83mf8+kf84mP8rqv83mP9Aj/8/kP87lP81mP9Ajf84mP84mf84lv88k/86lP81mv88kv84nP8/jv9Ajv9Bjf86lv9CjP83mv89kf84mf8jsP9FiP9EiP9Eif9Div9Fif////95uD+1AAAAh3RSTlMAWNfWNw2hwDbb3QJv+h7BVO6ZOPi8cj0MA337w3stH89wEfDzjh2RDuZ3qt5E8UXhW/qJaP1wLuv+RQKj9xFPzxLTcnn9+Agq6amv/h1V+LMZRW2n1fL8gxuH1v6REJTxdDKqIePvJYCCav7Ec+6eBoH089hI+nxupeHGP+Fx9vf5ufxi5oyvxS2sAAAAAWJLR0SNGwzi1QAAAAlwSFlzAAAB2AAAAdgB+lymcgAAAAd0SU1FB+gJBQEhKLTldiIAAAH1SURBVFjD7dXpPxtBGAfwJ4ir4qY07vtWS6rqiDsIcUuouu+7Leqmionjj+6ykt2dnd1kZt75+L2dfb4vfnMswHsMYwoJDeMYN4cjhCLY5yOjxHkUzTr+IcaCeIDYOIR4gPgExAOYExHiAaT2mAFfe6yAvz1GQG6PCVC2xwIkRWvmUXJKYurHtKDG0z9ZkU6sGZlZAeezM5BhcnLzDOdN+ShQCgqLaNojxVJcEnx75JSaSO2VWYKdF1OuqSJQe3gqsA2pDNwelqpqFfCZdl7sskYJCF763NcqgDobg/DwRSHUf2UQGr4phMamR3qhuUXZg72ZXmhVbUVbO73QoT4OnV20QLdDLfT00gp92JFudD7QAf0D+K1wDWq/ujdQhzT3ktClAMMjo2PjE08EwO3QCOCxaQApk1PfpzXCD8LjgJ9LQV6amZ3DgDnS64R1KagW5zFigSSoz6WALXrcSmCRCKi6xAFYWlYAK6ATuUtBu+iUgadVPcF/LgkArMm3d10P8HdJAmBj0wdsgX6kLokAbPt2ascAkLrU+WLXdx/2jAT4+eu3S2dp/1U4AMa0HUrAH1YAjiTgmBmAkxfglB04ewHO2QFY1r2QQebiGbjkAOBKBP7yANci8I8HuBGBaR7A0S/+p3kAuPV6bVyA/cp2xwW8kfwHCvbQWSXPeyAAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjQtMDktMDVUMDE6MzM6NDArMDA6MDDfLr9EAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDI0LTA5LTA1VDAxOjMzOjQwKzAwOjAwrnMH+AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="
      />
    </svg>
  );
};

export default RollbackIcon;
